function helperGetDateFullYear (date) {
  return date.getFullYear()
}

module.exports = helperGetDateFullYear



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/date/helperGetDateFullYear.js
// module id = 143
// module chunks = 106